<template>
  <div class="">
    <div class="menu-box" :style="{'position': scrollShow?'fixed':'relative'}">
      <div class="logo">
        <img src="../assets/images/pinnuologo.png" alt="">
      </div>
      <ul class="menu">
        <li class="m-item " @mouseenter="mouseenterN(item.id)"  @mouseleave="mouseleaveN(item.id)" :class="currentMenuId===item.id?'active':''" v-for="item in menuList" :key="item.id" @click="changeMenu(item)">
          <span class="p-r f-w-5">
			{{item.name}}
			 <!-- 品倍福 -->
		   <template v-if="item.id==3">
			<transition name="el-fade-in">
            <div class="common-box dis-flex flex-y-center" @mouseenter="fanShow3=true"  v-if="fanShow3">
                 <div class="dis-flex flex-y-center items" :class="currentMenuId===item.id&&selectIndex4==items.id?'jactives':''"  v-for="items in pbfChildren">
					<el-image class="iocns" :src="items.icon"/>
					<div class="col-3 f-14 m-l-14">{{items.name}}</div>
				 </div>
            </div>
            </transition>
		  </template>
		   <!-- 品诺商城 -->
		   <template v-if="item.id==-1">
			<transition name="el-fade-in">
            <div class="common-box w-236 dis-flex flex-y-center" @mouseenter="fanShow11=true" v-if="fanShow11">
                 <div class="dis-flex flex-y-center items" :class="currentMenuId===item.id&&selectIndex4==items.id?'jactives':''"  v-for="items in pnscChildren">
					<el-image class="iocns" :src="items.icon"/>
					<div class="col-3 f-14 m-l-14 w-n">{{items.name}}</div>
				 </div>
            </div>
            </transition>
		  </template>
		   <!-- 一起笑 -->
		   <template v-if="item.id==6">
			<transition name="el-fade-in">
            <div class="common-box w-302 dis-flex flex-y-center" @mouseenter="fanShow6=true"  v-if="fanShow6">
                 <div class="dis-flex flex-y-center items" :class="currentMenuId===item.id&&selectIndex4==items.id?'jactives':''"  v-for="items in pnyqxChildren">
					<el-image class="iocns" :src="items.icon"/>
					<div class="col-3 f-14 m-l-14 w-n">{{items.name}}</div>
				 </div>
            </div>
            </transition>
		  </template>
			<!-- 解决方案 -->
		  <template v-if="item.id==5">
			<el-image :src="shoulongIcon" v-if="currentMenuId===item.id||fanShow" class="shoulongIcon" :class="[currentMenuId===item.id&&!fanShow?'rote':'']"/>
			<el-image v-else :src="shoulong_Icon" class="shoulongIcon"/>
			<transition name="el-fade-in">
            <div class="jjfa-box" @mouseenter="fanShow=true" @mouseleave="fanShow=false" v-if="fanShow">
                 <div class="dis-flex flex-y-center items" :class="currentMenuId===item.id&&selectIndex==items.id?'jactives':''" @click.stop="childClick(items)" v-for="items in menuChildren">
					<el-image class="iocns" :src="items.icon"/>
					<div class="col-3 f-14 m-l-8">{{items.name}}</div>
				 </div>
            </div>
            </transition>
		  </template>
		  <!-- 关于我们 -->
		   <template v-if="item.id==4">
			<!-- <el-image :src="shoulongIcon" v-if="currentMenuId===item.id||fanShow4" class="shoulongIcon" :class="[fanShow4?'rote':'']"/> -->
			<el-image :src="shoulongIcon" v-if="currentMenuId===item.id||fanShow4" class="shoulongIcon"  :class="[currentMenuId===item.id&&!fanShow4?'rote':'']"/>
			<el-image v-else :src="shoulong_Icon" class="shoulongIcon"/>
			<transition name="el-fade-in">
            <div class="about-box" @mouseenter="fanShow4=true" @mouseleave="fanShow4=false" v-if="fanShow4">
                 <div class="dis-flex flex-y-center items" :class="currentMenuId===item.id&&selectIndex4==items.id?'jactives':''" @click.stop="childsClick(items)" v-for="items in aboutChildren">
					<div class="col-3 f-14 m-l-8">{{items.name}}</div>
				 </div>
            </div>
            </transition>
		  </template>
		  </span>
		  
        </li>

        <li class="m-item contact-tit">
          <div class="name f-w-5" @mouseenter="isShowContact=true" @mouseleave="isShowContact=false">联系我们 
			<el-image :src="shoulongIcon" v-if="isShowContact" class="shoulongIcon m-l-4" />
			<el-image v-else :src="shoulong_Icon" class="shoulongIcon m-l-4"/> 
			<!-- <span class="sanjiao" :class="isShowContact?'show':''"></span> -->
		 </div>
          <transition name="el-fade-in">
            <div class="contact-box" v-if="isShowContact">
              <div class="title col-3 f-16 f-w"><img src="../assets/images/weixin.png" alt=""> 微信公众号</div>
              <div class="qrcode">
                <img src="@/assets/images/qrcode.jpg" alt="">
              </div>
              <div class="text">
                <p class="tel col-3 f-16 f-w"><img src="../assets/images/dianhua.png" alt=""> 联系电话</p>
                <p class="mtb col-3 f-20 f-w">400-007-6666</p>
                <p class="f-16 col-3 f-16 dd">( 9:00-21:00 )</p>
                <p class="f-16 col-3 m-t-12 f-16 dd">全年无休</p>
              </div>
              <p v-if="isShowContact" class="whitesj"></p>
            </div>
          </transition>
        </li>

      </ul>
      <div class="m-item mall">
        <div class="market " @click="jumpToMall">在线福利商城 <img src="@/assets/images/home/top_icon.png" alt=""></div>
      </div>
    </div>
    <!-- 登录 -->
    <el-dialog class="login_box" :visible.sync="loginVisible" top="30vh" width="420px" :show-close="false">
      <div class="title"> 北京品诺优创科技有限公司</div>
      <div class="price">行业资讯登录付费方可观看0.5元/条</div>
      <div class="form">
        <div class="form_item">
          <div class="label">用户名</div>
          <div class=""><input class="input" type="text" placeholder="请输入用户名"></div>
        </div>
        <div class="form_item">
          <div class="label">密&nbsp;&nbsp;&nbsp;码</div>
          <div class=""><input class="input" type="text" placeholder="请输入密码"></div>
        </div>
      </div>
      <div class="btn_box">
        <div class="btn1">登录</div>
        <div class="btn2" @click="loginVisible=false">关闭</div>
      </div>
    </el-dialog>
    <!-- 注册 -->
    <el-dialog class="login_box" :visible.sync="registerVisible" top="20vh" width="420px" :show-close="false">
      <div class="title"> 北京品诺优创科技有限公司</div>
      <div class="price">行业资讯登录付费方可观看0.5元/条</div>
      <div class="form">
        <div class="form_item">
          <div class="label">邮 箱</div>
          <div class=""><input class="input" v-model="form.email" type="text" placeholder="请输入邮箱"></div>
        </div>
        <div class="form_item">
          <div class="label">密 码</div>
          <div class=""><input class="input" type="password" v-model="form.pwd" placeholder="请输入密码"></div>
        </div>
        <div class="form_item">
          <div class="label">确认密码</div>
          <div class=""><input class="input" v-model="form.repwd" type="password" placeholder="请再次输入密码"></div>
        </div>
        <div class="form_item">
          <div class="label">姓 名</div>
          <div class=""><input class="input" v-model="form.name" type="text" placeholder="请输入姓名"></div>
        </div>
        <div class="form_item">
          <div class="label">身份证</div>
          <div class=""><input class="input" v-model="form.id" type="text" placeholder="请输入身份证号"></div>
        </div>
        <div class="form_item">
          <div class="label">手机号</div>
          <div class=""><input class="input" v-model="form.tel" type="text" placeholder="请输入手机号"></div>
        </div>
      </div>
      <div class="btn_box">
        <div class="btn1">注册</div>
        <div class="btn2" @click="resetForm">重置</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {
      loginVisible: false,
      registerVisible: false,
      form: {
        email: '',
        pwd: '',
        repwd: '',
        name: '',
        id: '',
        tel: '',
      },
      menuList: [
        { id: 1, name: '首页', path: '/' },
        { id: 3, name: '品倍福', path: '/pbf' },
        { id: -1, name: '品诺商城', path: '/pnsc' },
        { id: 6, name: '易企销', path: '/pnyqx' },
        // { id: 2, name: '产品与服务', path: '/servers' },
        { id: 5, name: '解决方案', path: '/jjfa' },
        { id: 4, name: '关于我们', path: '/about' },
        // { id: 5, name: '公司动态', path: '/news' },
        // { id: 6, name: '登录', path: '/' },
        // { id: 7, name: '注册', path: '/' },
      ],
      currentMenuId: 1,
      isShowContact: false,
	  menuChildren:[
		{
			name:'年节慰问福利解决方案',
			icon:require("@/assets/images/jjfa/years/年节@2x (1).png"),
			selcetbg:'#FFF5F5',
			id:1,
		},
		{
			name:'生日慰问福利解决方案',
			icon:require("@/assets/images/jjfa/years/生日慰问@2x.png"),
			selcetbg:'#FFF9F5',
			id:2,
		},
		{
			name:'观影福利解决方案',
			icon:require("@/assets/images/jjfa/years/观影福利@2x.png"),
			selcetbg:'#F7F5FF',
			id:3,
		},
		{
			name:'员工餐补解决方案',
			icon:require("@/assets/images/jjfa/years/餐补福利@2x.png"),
			selcetbg:'#FFFDEE',
			id:4,
		},
		{
			name:'企业活动解决方案',
			icon:require("@/assets/images/jjfa/years/企业活动@2x.png"),
			selcetbg:'#F5F9FF',
			id:5,
		},
	  ],
	  aboutChildren:[
		{
			name:'公司介绍',
			selcetbg:'#FFF5F5',
			id:1,
		},
		{
			name:'品诺资讯',
			selcetbg:'#FFF5F5',
			id:2,
		},
	  ],
	  pbfChildren:[
		{
			name:'福利智慧化交付及管理平台', 
			icon:require("@/assets/images/header/品倍福@2x.png"),
		},
	  ],
	  pnscChildren:[
		{
			name:'一站式福利交付平台', 
			icon:require("@/assets/images/header/易企销@2x.png"),
		},
	  ],
	  pnyqxChildren:[
		{
			name:'职工福利供应链整合及运营平台', 
			icon:require("@/assets/images/header/易企销@2x (1).png"),
		},
	  ],
	  shoulongIcon:require("@/assets/images/jjfa/years/收起@2x.png"),
	  shoulong_Icon:require("@/assets/images/jjfa/years/收起@2x2.png"),
	  fanShow:false,
	  selectIndex:'',
	  fanShow4:false,
	  selectIndex4:'',
	  fanShow3:false,
	  selectIndex3:'',
	  fanShow11:false,
	  fanShow6:false,
	  scrollShow:false,
    }
  },
  created() {},
  mounted() {
	window.addEventListener('scroll',(e)=>{
        this.scrollShow=window.scrollY>80
	})
  },
  beforeDestroy(){
   window.removeEventListener('scroll',()=>{})
  },
  methods: {
    // 展示联系我们
    showContactUs() {
      this.isShowContact = !this.isShowContact
    },
    // 切换菜单
    changeMenu(item) {
      this.currentMenuId = item.id
      if (item.id < 7) {
        // this.isShowContact=false
		if(item.id==5){
		this.fanShow=true
		let current=this.menuChildren.find(item=>this.$route.query.id==item.id)||this.menuChildren[0]
        this.childClick(current)
		}else if(item.id==4){
		this.fanShow4=true
		let current=this.aboutChildren.find(item=>this.$route.query.id==item.id)||this.aboutChildren[0]
        this.childsClick(current)
		}else{
         this.$router.push(item.path)
		}
      } else if (item.id === 7) {
        // 登录
        this.loginVisible = true
      } else {
        // 注册
        this.registerVisible = true
      }
    },
    jumpToMall() {
	  if(window.location.origin.indexOf('.21')!=-1){
      window.location.href='http://192.168.0.21:18093/mall_pc/index.html';
	  }else{
      window.location.href = 'https://www.pinuc.com/mall_pc/index.html'
	  }
    },
    resetForm() {
      this.form = {
        email: '',
        pwd: '',
        repwd: '',
        name: '',
        id: '',
        tel: '',
      }
    },
	//解决方案
	childClick(item){
        this.selectIndex=item.id
		if(this.$route.query.id!=item.id||this.$route.name!='jjfa'){
          this.$router.replace({
			path:'/jjfa',
			query:{
				id: item.id,
			}
		  })
		  this.fanShow=false
		}
       
	},
	//关于我们
	childsClick(item){
        this.selectIndex4=item.id
		console.log(this.$route)
		if(this.$route.query.id!=item.id||this.$route.name!='about'){
          this.$router.replace({
			path:'/about',
			query:{
				id: item.id,
			}
		  })
		  this.fanShow4=false
		}
       
	},
	mouseleaveN(id){
         if(id==5){
			this.fanShow=false
		 }else if(id==4){
			this.fanShow4=false
		 }else if(id==3){
			this.fanShow3=false
		 } else if(id==-1){
			this.fanShow11=false
		 }else if(id==6){
			this.fanShow6=false
		 }
	},
	mouseenterN(id){
		console.log('mouseenterN',id)
         if(id==5){
			this.fanShow=true
			this.fanShow4=false
			this.fanShow3=false
			this.fanShow11=false
			this.fanShow6=false
		 }else if(id==4){
			this.fanShow4=true
			this.fanShow=false
			this.fanShow3=false
			this.fanShow6=false
			this.fanShow11=false
		 }
		 else if(id==3){
			this.fanShow3=true
			this.fanShow=false
			this.fanShow4=false
			this.fanShow11=false
			this.fanShow6=false
		 } else if(id==-1){
			this.fanShow11=true
			this.fanShow4=false
			this.fanShow=false
			this.fanShow3=false
			this.fanShow6=false
		 }
		 else if(id==6){
			this.fanShow6=true
			this.fanShow4=false
			this.fanShow=false
			this.fanShow3=false
			this.fanShow11=false
		 }else {
			this.fanShow4=false
			this.fanShow=false
			this.fanShow3=false
			this.fanShow11=false
			this.fanShow6=false
		 }
	}
  },
  filters: {},
  computed: {},
  watch: {
    $route(val) {
      switch (val.path) {
        case '/':
          this.currentMenuId = 1
          break
        case '/servers':
          this.currentMenuId = 2
          break
        case '/pbf':
          this.currentMenuId = 3
          break
        case '/about':
          this.currentMenuId = 4
          break
        case '/news':
          this.currentMenuId = 5
          break
        case '/pnyqx':
          this.currentMenuId = 6
          break
		case '/pnsc':
          this.currentMenuId = -1
          break
		  case '/jjfa':
          this.currentMenuId = 5
          break
		  
        default:
          break
      }
    },
  },
}
</script>

<style lang="less" scoped>
.menu-box {
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 11111;
  left: 0;
  height: 70px;
  background: #fff;
  opacity: 1;
  display: flex;
  align-items: center;
  padding: 0 90px;
  box-sizing: border-box;
  border-bottom: 1px solid #E1E0DE;
  min-width: 1440px;
  .logo {
    width: 17%;
    background: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    // line-height: 70px;
    height: 38px;
    // padding-top: 5px;
    box-sizing: border-box;
    img {
      width:94px;
      height: 38px;
    }
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70%;
    background: #fff;
    // padding: 0 20px;
    padding-right: 20px;
    font-size: 20px;
    position: relative;
    box-sizing: border-box;
    border-bottom: 1px solid #E1E0DE;
    .m-item {
      width: 20%;
      height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      cursor: pointer;
	  color:#333;
	  font-size: 16px;
      // &:last-child{
      //   span{
      //     border-right: 1px solid #999999;
      //   }

      // }
      // box-sizing: border-box;
      &::before {
        content: '';
        display: block;
      }
      &::after {
        content: '';
        width: 78px;
        height: 4px;
        display: block;
        background: transparent;
        opacity: 1;
        border-radius: 3px 3px 0 0;
      }
      &.active {
        color:#FE9C2C;
        font-weight: bold;
		font-size: 16px;
        &::after {
          background: #FE9C2C;
        }
      }
      .name {
        display: flex;
        align-items: center;
        // border-right: 1px solid #999999;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 36px;
        .sanjiao {
          width: 0;
          height: 0;
          display: block;
          border: 7px solid;
          margin-left: 6px;
          border-color: transparent transparent #333333 transparent;
          margin-top: -8px;
          &.show {
            border-color: #333333 transparent transparent transparent;
            margin-top: 8px;
          }
        }
      }
	  &:hover{
		color:#FE9C2C;
        font-weight: bold;
		font-size: 16px;
	  }
    }
  }
  .mall {
    width: 130px;
    height: 40px;
    background: linear-gradient( 90deg, #FFB800 0%, #FF9113 100%);
    border-radius: 100px;
    line-height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    .market {
      display: flex;
      align-items: center;
      color: #fffeff;
      font-size: 14px;
      cursor: pointer;
      img {
        width: 8px;
        height: 14px;
        margin-left: 10px;
      }
    }
  }
  .contact-tit {
    position: relative;
    //   联系我们
    .contact-box {
      position: absolute;
      top: 97px;
      right: -45px;
      width: 200px;
      height: 380px;
      background: #ffffff;
      border-radius: 10px;
      // padding: 27px 16px;
      .whitesj {
        position: absolute;
        top: -36px;
        right: 78px;
        width: 0;
        height: 0;
        display: block;
        border: 24px solid;
        border-color: transparent transparent #fff transparent;
        z-index: -1;
      }
      .title {
        text-align: center;
        margin-top: 27px;
        display: flex;
		font-size: 16px;
        align-items: center;
        justify-content: center;
        img {
          height: 21px;
          margin-right: 7px;
        }
      }
      .qrcode {
        margin: 5px 16px 0;
        img {
          width: 150px;
        }
      }
      .text {
        background: #f3f3f3;
        padding: 30px 0 30px;
        border-radius: 0px 0px 10px 10px;
        font-family: Source Han Sans CN;
        .tel {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            margin-right: 8px;
			width: 24px;
			height: 24px;
          }
        }
        p {
          text-align: center;
        }
        .mtb {
          font-family: Source Han Sans CN;
          margin-top: 17px;
          margin-bottom: 10px;
          font-size: 20px;
          font-weight: bold;
        }
		.dd{
			font-weight: normal !important;
		}
      }
    }
  }
  .shoulongIcon{
	width: 12px;
	height: 8px;
  }
  .rote{
	transform: rotate(180deg);
  }
  .grote{
	transform: rotate(180deg);
  }
  .jjfa-box{
	position: absolute;
	width: 460px;
    height: 170px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 0px rgba(0,0,0,0.16);
    border-radius: 4px 4px 4px 4px;
	padding: 12px;
	box-sizing: border-box;
	top: 44px;
	left: 0px;
	display: grid;
      grid-template-columns: 210px 210px;
      grid-gap: 0px 10px;
      margin: 0 auto;
	  .items{
		width: 210px;
        height: 50px;
        border-radius: 4px 4px 4px 4px;
		padding-left: 10px;
		box-sizing: border-box;
		cursor: pointer;
		.iocns{
			width: 26px;
			height: 26px;
			display: block;
		}
		&:hover{
		   background: #FFF9F5; 
		   position: relative;
		}
	  }
	  .jactives{
        background: #FFF9F5; 
		position: relative;
	  }

  }
  .about-box{
	position: absolute;
	width: 120px;
    height: 130px;
    background: #ffffff;
    box-shadow: 2px 4px 12px 0px rgba(0,0,0,0.16);
    border-radius: 4px 4px 4px 4px;
	padding: 12px;
	box-sizing: border-box;
	top: 44px;
	left: 0px;
      margin: 0 auto;
	  .items{
		width: 90px;
        height: 50px;
        border-radius: 4px 4px 4px 4px;
		padding-left: 10px;
		box-sizing: border-box;
		cursor: pointer;
		.iocns{
			width: 26px;
			height: 26px;
			display: block;
		}
		&:hover{
		   background: #FFF9F5; 
		   position: relative;
		}
	  }
	  .jactives{
        background: #FFF9F5; 
		position: relative;
	  }
  }
}

.login_box {
  border-radius: 10px;
  .title {
    text-align: center;
    font-size: 24px;
    color: #333333;
    line-height: 33px;
  }
  .price {
    font-size: 16px;
    text-align: center;
    color: #fb3f45;
    line-height: 22px;
    margin-top: 15px;
  }
  .form {
    margin-top: 45px;
    .form_item {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      .label {
        font-size: 14px;
        color: #333333;
        line-height: 22px;
        // margin-right: 10px;
        width: 70px;
      }
      .input {
        width: 290px;
        height: 40px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #e6e6e6;
        padding: 0 10px;
        box-sizing: border-box;
        &:focus-visible {
          outline: none;
        }
      }
    }
  }
  .btn_box {
    margin-top: 32px;
    .btn1 {
      width: 360px;
      height: 48px;
      background: #ee8f36;
      border-radius: 2px;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .btn2 {
      width: 360px;
      height: 48px;
      background: #fff;
      border-radius: 2px;
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}
.common-box{
	width: 288px;
    height: 62px;
    background: #FFFFFF;
    box-shadow: 2px 4px 12px 0px rgba(0,0,0,0.16);
    border-radius: 4px 4px 4px 4px;
	position: absolute;
	box-sizing: border-box;
	padding: 0 20px;
	top: 44px;
	left: -14px;
	.iocns{
		width: 56px;
		height: 22px;
	}
}
.w-236{
	width: 236px;
}
.w-302{
	width: 302px;
}
</style>



// WEBPACK FOOTER //
// src/components/pageHeader.vue